// =========================================================
// * Austin Cloud
// =========================================================

import "@fortawesome/fontawesome-free/css/all.css";
import "react-datetime/css/react-datetime.css";
import "react-toastify/dist/ReactToastify.css";

import "./scss/volt.scss";

import axios from "axios";
import TimeAgo from "javascript-time-ago";
import en from "javascript-time-ago/locale/en.json";
import ReactDOM from "react-dom/client";

import { App } from "./components";
import { initOidcConfig } from "./components/auth";
import { isBlast, isTech } from "./utils";
import { updateSentry } from "./utils/sentry";

updateSentry();

TimeAgo.addDefaultLocale(en);

axios.defaults.baseURL = isTech
	? import.meta.env.VITE_API_URL_TECH
	: import.meta.env.VITE_API_URL;
axios.defaults.headers.post["Content-Type"] = "application/json";

if (
	import.meta.env.VITE_IS_REDIRECT !== "false" &&
	window.location.origin.includes("igneous.tech")
) {
	const redirectURL = new URL(
		window.location.pathname,
		isBlast ? import.meta.env.VITE_BLAST_UI : import.meta.env.VITE_CRM_UI,
	);

	window.location.href = redirectURL.href;
} else {
	// Resolve the OIDC config (sameDomain off the real issuer for non-.com hosts)
	// before mounting AuthProvider, so it gets the correct values.
	// Wrapped in an async IIFE because the build target doesn't allow top-level await.
	void (async () => {
		await initOidcConfig();
		const root = ReactDOM.createRoot(
			document.getElementById("root") as HTMLElement,
		);
		root.render(<App />);
	})();
}
